import { Component, Input } from '@angular/core';
import { DigiluguReferral } from 'app/integration/document/services/digilugu-referral';
import { ClinicalDocumentService } from 'app/integration/document/services/clinical-document.service';
import { Referral } from 'app/reception/lib/services/referral/referral';

@Component({
  selector: 'hw-response-referral-details',
  templateUrl: './response-referral-details.component.html'
})

export class ResponseReferralDetailsComponent {
  @Input() public referral: Referral;
  @Input() public dlReferral: DigiluguReferral;

  constructor(
    private documentService: ClinicalDocumentService
  ) {}

  public openDocument(referral: DigiluguReferral): void {
    this.documentService.openDocument('e-visit', referral.identifier, referral.patient.identifier);
  }
}
